import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import QuotePage from './pages/QuotePage';
import ContactPage from './pages/ContactPage';
import ContentPage from './pages/ContentPage';
import Varmepumper from './pages/Varmepumper';
import About from './pages/About';
import VVS from './pages/VVS';
import Blikkenslager from './pages/Blikkenslager';
import Fjernvarme from './pages/Fjernvarme';
import Badevaerelser from './pages/Badevaerelser';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Danish Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/tilbud" element={<QuotePage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/blikkenslager" element={<Blikkenslager />} />
          <Route path="/nybyggeri" element={<ContentPage slug="nybyggeri" />} />
          <Route path="/erhverv" element={<ContentPage slug="erhverv" />} />
          <Route path="/referencer" element={<ContentPage slug="referencer" />} />
          <Route path="/karriere" element={<ContentPage slug="karriere" />} />
          <Route path="/faq" element={<ContentPage slug="faq" />} />
          <Route path="/privatlivspolitik" element={<ContentPage slug="privatlivspolitik" />} />
          <Route path="/service-og-vedligehold" element={<ContentPage slug="service-og-vedligehold" />} />

          {/* VVS Subpages */}
          <Route path="/vvs" element={<VVS />} />
          <Route path="/vvs/badevaerelser" element={<Badevaerelser />} />
          <Route path="/badevaerelser" element={<Badevaerelser />} />
          <Route path="/vvs/roerinstallationer" element={<ContentPage slug="vvs-roerinstallationer" />} />
          <Route path="/vvs/ventilation" element={<ContentPage slug="vvs-ventilation" />} />
          <Route path="/vvs/akut-vvs" element={<ContentPage slug="vvs-akut-vvs" />} />

          {/* Varme Subpages */}
          <Route path="/varme/varmepumper" element={<Varmepumper />} />
          <Route path="/varme/fjernvarme" element={<Fjernvarme />} />
          <Route path="/fjernvarme" element={<Fjernvarme />} />
          <Route path="/varme/varmeanlaeg" element={<ContentPage slug="varme-varmeanlaeg" />} />

          {/* Guides Subpages */}
          <Route path="/guides" element={<ContentPage slug="guides" />} />
          <Route path="/guides/hvad-koster-en-varmepumpe" element={<ContentPage slug="guides-hvad-koster-en-varmepumpe" />} />
          <Route path="/guides/frostspraengte-roer" element={<ContentPage slug="guides-frostspraengte-roer" />} />
          <Route path="/guides/fjernvarme-eller-varmepumpe" element={<ContentPage slug="guides-fjernvarme-eller-varmepumpe" />} />

          {/* City / Områder Subpages */}
          <Route path="/vvs-billund" element={<ContentPage slug="vvs-billund" />} />
          <Route path="/vvs-grindsted" element={<ContentPage slug="vvs-grindsted" />} />
          <Route path="/vvs-give" element={<ContentPage slug="vvs-give" />} />
          <Route path="/vvs-vejle" element={<ContentPage slug="vvs-vejle" />} />
          <Route path="/vvs-soender-omme" element={<ContentPage slug="vvs-soender-omme" />} />

          {/* English Routes */}
          <Route path="/en" element={<HomePage />} />
          <Route path="/en/get-a-quote" element={<QuotePage />} />
          <Route path="/en/contact" element={<ContactPage />} />
          <Route path="/en/about" element={<About />} />
          <Route path="/en/sheet-metal" element={<Blikkenslager />} />
          <Route path="/en/new-construction" element={<ContentPage slug="en-new-construction" />} />
          <Route path="/en/commercial" element={<ContentPage slug="en-commercial" />} />
          <Route path="/en/references" element={<ContentPage slug="en-references" />} />
          <Route path="/en/careers" element={<ContentPage slug="en-careers" />} />
          <Route path="/en/faq" element={<ContentPage slug="en-faq" />} />
          <Route path="/en/privacy-policy" element={<ContentPage slug="en-privacy-policy" />} />
          <Route path="/en/service-maintenance" element={<ContentPage slug="en-service-maintenance" />} />

          {/* English Plumbing Subpages */}
          <Route path="/en/plumbing" element={<VVS />} />
          <Route path="/en/plumbing/bathrooms" element={<Badevaerelser />} />
          <Route path="/en/bathrooms" element={<Badevaerelser />} />
          <Route path="/en/plumbing/pipework-water-damage" element={<ContentPage slug="en-plumbing-pipework-water-damage" />} />
          <Route path="/en/plumbing/ventilation" element={<ContentPage slug="en-plumbing-ventilation" />} />
          <Route path="/en/plumbing/emergency" element={<ContentPage slug="en-plumbing-emergency" />} />

          {/* English Heating Subpages */}
          <Route path="/en/heating/heat-pumps" element={<Varmepumper />} />
          <Route path="/en/heating/district-heating" element={<Fjernvarme />} />
          <Route path="/en/district-heating" element={<Fjernvarme />} />
          <Route path="/en/heating/heating-systems" element={<ContentPage slug="en-heating-heating-systems" />} />

          {/* English Guides Subpages */}
          <Route path="/en/guides" element={<ContentPage slug="en-guides" />} />
          <Route path="/en/guides/heat-pump-cost" element={<ContentPage slug="en-guides-heat-pump-cost" />} />
          <Route path="/en/guides/frozen-pipes" element={<ContentPage slug="en-guides-frozen-pipes" />} />
          <Route path="/en/guides/district-heating-or-heat-pump" element={<ContentPage slug="en-guides-district-heating-or-heat-pump" />} />

          {/* English Plumber City Subpages */}
          <Route path="/en/plumber-billund" element={<ContentPage slug="en-plumber-billund" />} />
          <Route path="/en/plumber-grindsted" element={<ContentPage slug="en-plumber-grindsted" />} />
          <Route path="/en/plumber-give" element={<ContentPage slug="en-plumber-give" />} />
          <Route path="/en/plumber-vejle" element={<ContentPage slug="en-plumber-vejle" />} />
          <Route path="/en/plumber-soender-omme" element={<ContentPage slug="en-plumber-soender-omme" />} />

          {/* Legacy redirects */}
          <Route path="/firmaprofil" element={<Navigate to="/om-os" replace />} />
          <Route path="/kontakt-os" element={<Navigate to="/kontakt" replace />} />
          <Route path="/vvs-arbejde" element={<Navigate to="/vvs" replace />} />
          <Route path="/varme" element={<Navigate to="/varme/varmeanlaeg" replace />} />
          <Route path="/varmepumper" element={<Varmepumper />} />
          <Route path="/ventilation" element={<Navigate to="/vvs/ventilation" replace />} />

          {/* Catch-all fallback to Home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
